import { j as a } from "./jsx-runtime-3tyXYecC.mjs";
import { B as n } from "./base-headline-Dw8BrcrM.mjs";
function t(e) {
  return /* @__PURE__ */ a.jsx(n, { ...e, "data-fabric-component": "Headline" });
}
export {
  t as H
};
//# sourceMappingURL=headline-DF2GOgMa.mjs.map
